export default ('dollarsToCents', originalValue => Math.round(parseFloat(originalValue) * 100));
